import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LandingPage from './pages/LandingPage'

function Portfolio() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
      </Routes>
    </>
  )
}

export default Portfolio
